<template>
  <div class="row" style="display: block;">
    <div
      class="text-center"
      style="z-index:99;height:40%;background-color:#ff5855;padding-top:5%;padding-bottom:10%;"
    >
      <b style="color:#fff;">
        <img src="img/brand/white.png" class="img-responsive logo" style="width:40%" />
      </b>
    </div>
    <div class="col-lg-5 col-md-7" style="margin-top:-7%;margin-left:0%;z-index:100">
      <div class="card bg-secondary shadow border-0" style="border-radius:10px;">
        <div
          class="card-body px-lg-5 py-lg-5 shadow"
          style="border:2px solid #d0d0d0;border-radius:10px;"
        >
          <div style="margin-top:-20px">
            <div class="text-center text-muted mb-4">
              <p style="font-weight:bold;font-size:26px;color:#ff5855">Cargando</p>
            </div>
            <div class="col-md-12 text-center">
              <img src="img/icons/rs_cargando.gif" />
            </div>

            <div class="text-center text-muted mb-4" style="font-weight:bold;font-size:12px">
              <br />Serás redirigido a Resimple.
              <br />Aguardá un momento por favor.
            </div>
            <div class="col-md-4" style="margin-left:22%">
              <base-button
                type="danger"
                size="md"
                @click="goToAppClick"
                :disabled="model.disableButtonGoToApp"
              >VOLVER A RESIMPLE</base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.label-link {
  cursor: pointer;
}
</style>
<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  name: "redirect",
  data() {
    return {
      model: {
        countDown: 3,
        state: this.$route.query.Code,
        disableButtonGoToApp: true
      }
    };
  },
  methods: {
    countDownTimer() {
      let context = this;
      if (context.model.countDown > 0) {
        setTimeout(() => {
          context.model.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        context.model.disableButtonGoToApp = false;
        //context.$router.push("redir");
        window.location.href = window.location.origin + "/enrollment?Code=" + context.model.state;
      }
    },
    goToAppClick() {
      this.SignalRNotify();
    },
    SignalRNotify() {
      let context = this;
      axiosHelpers.axiosPost(
        "Enrollment/SignalRNotify",
        { State: context.model.state },
        context,
        function(data) {}
      );
    }
  },
  beforeMount: function() {
    this.countDownTimer();
  }
};
</script>
